import { store } from 'Store/store.index';
import axios from 'axios';
import qs from 'qs';
import _get from 'lodash/get';
import { HttpRequest } from './request.utils';
import { URL_CWS_API } from './constants';
import { baseUrlApis } from './index';
import { blobToBase64 } from 'Utils/utils'
import { URL_FOXIT_SIGN } from "Api/constants";
export default class FoxitSignApis extends HttpRequest {
  constructor() {
    super();
    // this.BASEURL = 'https://fs-dev.3pv.net/api/';
    // this.BASEURL = 'https://pheeplatform-demo4.connectedpdf.com/platform/api/';
    // this.BASEURL = 'https://pheeplatform-fzk8s.connectedpdf.com/platform/api/';
    this.initialize();
    this.CPDFURI = null;
    this.FORWARDAPI = '/client/forward-api';
  }
  initialize = () => {
    try {
      baseUrlApis.getBaseUrlBy(URL_CWS_API).then((data) => {
        this.CPDFURI = data;
        const axiosClient = axios.create({
          baseURL: `${this.CPDFURI}/cpdfapi/v1/`,
        });

        super.initialize(axiosClient, () => {
          this.interceptorsFn();
        });
      });
    } catch (error) {
      throw error;
    }
  };
  initialize() {}
  submitEnvelope({ fileData, fileName, fileExtension, config }) {
    let url = '/platform/api/foxitsign/v1.0/envelopes';
    return this.post({
      url,
      data: {
        request: {
          content: {
            documents: [
              {
                file: {
                  fileToUpload: {
                    data: fileData,
                    fileName: fileName,
                  },
                  extension: fileExtension,
                },
                name: fileName,
              },
            ],
          },
          generateSetupUrl: true,
          ssoTokenLifetime: 30,
          useIncrementalSigning: true,
        },
      },
      config,
    });
  }
  addDocumentToEnvelope({ fileData, fileName, fileId, fileExtension, updateProgress, updateCancelSource }) {
    const { jwt, foxitSignEnvelopeInfo } = store.userStore;
    const source = this.getCancelSource();
    const config = {
      headers: {
        Authorization: `Bearer ${jwt}`,
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'X-AS-User-Agent': 'FoxitSign/1.0.0',
      },
      params: {
        type: 'webBased',
        access_token: store.userStore.token,
        urlPrefix: 'https://fs-dev.3pv.net',
      },
      onUploadProgress: function (progressEvent) {
        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

        updateProgress && updateProgress({ percent: percentCompleted, fileId });
      },
      cancelToken: source.token,
    };

    updateCancelSource && updateCancelSource(source);

    if (foxitSignEnvelopeInfo) {
      const url = `/platform/api/foxitsign/v1.0/envelopes/${foxitSignEnvelopeInfo.preparedEnvelopeID}/documents`;
      const data = {
        request: {
          documents: [
            {
              file: {
                fileToUpload: {
                  data: fileData,
                  fileName: fileName,
                },
                extension: fileExtension,
              },
              name: fileName,
            },
          ],
        },
      };

      return this.post({ url, data, config });
    } else {
      return this.submitEnvelope({ fileData, fileName, fileExtension, config });
    }
  }
  requestSingleSignOnToken() {
    const url = '/platform/api/foxitsign/v1.0/authentication/sso';
    const { jwt } = store.userStore;

    return this.post({
      url,
      config: {
        headers: {
          Authorization: `Bearer ${jwt}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-AS-User-Agent': 'FoxitSign/1.0.0',
        },
        params: {
          type: 'webBased',
          access_token: store.userStore.token,
          urlPrefix: 'https://fs-dev.3pv.net',
        },
      },
    });
  }
  // Create Envelope via Base64/URL
  createEnvelopViaBase64(fileNameArr, base64FileArr) {
    return this.createESignAccessToken().then( access_token => {
      return this.post({
        url: this.FORWARDAPI,
        config: {
          params: {
            access_token
          },
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
        data: {
          apiKey: 'fs_folders_createfolder',
          folderName: fileNameArr[0],
          base64FileString: base64FileArr,
          fileNames: fileNameArr,
          envelopeTransactionSource: 'foxitEditor-txn',
          inputType: 'base64',
          createEmbeddedSendingSession: true,
          enableStepByStep: true,
          processAcroFields: false,
          processTextTags: false,
        },
      });
    }, err => {
      return Promise.reject(err);
    })
  }
  getUserJWT() {
    const { jwt } = store.userStore;
    return (jwt ? Promise.resolve(jwt): store.userStore.getUserJWT('FoxitSign')).then( result => {
      let _jwt = jwt;
      if (!jwt) {
        if (result.ret === 0) {
          _jwt = (result.data.jwt || '').replaceAll('.', '%2E');
          store.userStore.updateJWT(_jwt);
        } 
      }
      if (!_jwt) {
        return Promise.reject('Get JWT error! ')
      }
      return Promise.resolve(_jwt);
    }, () => {
      Promise.reject('Get token error! ')
    })
  }
  // Create Access token from Foxit Sign access token
  createESignAccessToken() {
    return this.getUserJWT().then( jwt => {
      return new Promise((resolve, reject) => {
        let { currentESignAccountId } = store.foxitSignStore;
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              foxit_access_token: jwt,
              companyId: currentESignAccountId
            },
          },
          data: {
            apiKey: 'api/v1/oauth2/access_token',
            'contentType': 'application/x-www-form-URLencoded',
          }
        }).then( (res = {}) => {
          let { ret,  data: { forwardResult: { access_token = '' } = {}} = {}} = res;
          if (ret ===  0 && access_token) {
            store.userStore.updateESignToken(access_token);
            resolve(access_token);
          } else {
            reject('Get token error! ')
          }
        }, () => {
          reject('Get token error! ')
        })
      })
    }, () => {
      Promise.reject('Get token error! ')
    })
  }
  getFoxitSignHost() {
    let host = store.appStore.phantomOnlineGlobalConfig ?  store.appStore.phantomOnlineGlobalConfig[URL_FOXIT_SIGN] : '';
    return host;
  }
  // Embedded URL
  createEmbeddedUrl() {
    let { full } = store.appStore.lng;
    return this.createESignAccessToken().then( access_token => {
      let host = this.getFoxitSignHost();
      return host ? Promise.resolve(`${host}/documentsList?accessToken=${access_token}&lang=${full}`) : Promise.reject('Not support Env! ');
    }, err => {
      Promise.reject(err);
    })
  }
  createFoxitEsignSignature(params = {}) {
    return this.createESignAccessToken().then( access_token => {
      return new Promise((resolve, reject) => {
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token
            },
          },
          data: {
            apiKey: 'api/parties/saveDefaultSignature',
            'contentType': 'application/json',
            ...params
          }
        }).then( (res = {}) => {
          let { ret,  data: { forwardResult = {} } = {}} = res;
          if (ret === 0) {
            resolve(forwardResult);
          } else {
            reject('Create EsignSignature error! ')
          }
        }, (err) => {
          reject(err)
        })
      });
    }, err => {
      return Promise.reject(err);
    })
  }
  deleteFoxitEsignSignature(fieldType) {
    return this.createESignAccessToken().then( access_token => {
      return new Promise((resolve, reject) => {
        this.get({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token,
              apiKey: 'api/parties/deleteDefaultSignImage',
              fieldType
            },
          }
        }).then( (res = {}) => {
          let { ret,  data: { forwardResult = {}} = {}} = res;
          if (ret ===  0 && forwardResult && forwardResult.result === 'success') {
            resolve(forwardResult);
          } else {
            reject('Delete EsignSignature error! ')
          }
        }, err => {
          reject(err)
        })
      });
    }, err => {
      return Promise.reject(err);
    })
  }
  getFoxitEsignSignature(fieldType, isUseCacheESignToken = false) {
    let { eSign_token }  = store.userStore;
    return (isUseCacheESignToken && eSign_token ? Promise.resolve(eSign_token) : this.createESignAccessToken()).then( access_token => {
      return new Promise((resolve, reject) => {
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token
            },
          },
          data: {
            apiKey: 'api/parties/getPartySignImage',
            'contentType': 'application/json',
            fieldType
          }
        }).then( (res = {}) => {
          let { ret,  data: { forwardResult: { result = '', imageSource = '', imageSourceWithDetails = '' } = {}} = {}} = res;
          if (ret ===  0 && result ==='success') {
            resolve({imageSource, imageSourceWithDetails});
          } else {
            reject('Get EsignSignature error! ')
          }
        }, () => {
          reject('Get EsignSignature error! ')
        })
      });
    }, err => {
      return Promise.reject(err);
    })
  }

  downloadEnvelopePDF(folderId, documentsListCount = 1) {
    return this.createESignAccessToken().then( access_token => {
      let url = this.getFoxitSignHost();
      if (url) {
        url += `${url.endsWith('/') ? '' : '/'}api/folders/document/download`;
        let promises = [];
        for (let index = 0; index < documentsListCount; index++) {
          promises.push(this.get({
            url,
            config: {
              params: {
                access_token,
                folderId,
                docNumber: index + 1
              },
              responseType: 'blob'
            }
          }))
        }
        return Promise.all(promises);
      } else {
        return Promise.reject('Download PDF Error! ');
      }
    }, err => {
      return Promise.reject(err);
    })
  }

  queryESignAllAgreementsListByFolderIds(access_token, folderIds = []){
    return this.get({
      url: this.FORWARDAPI,
      config: {
        params: {
          access_token,
          apiKey: 'api/folders/list/all',
          folderids: folderIds.join(',')
        },
      },
    })
  }

  queryESignAllAgreementsListFoldersByIndex(access_token, startindex = 0) {
    return this.get({
      url: this.FORWARDAPI,
      config: {
        params: {
          access_token,
          startindex,
          apiKey: 'api/folders/list/count/all',
        },
      },
    })
  }


  queryESignAllAgreementsList(access_token)  {
    // 首先获取 startIndex = 0的数据 （1-50）
    const PAGE_SIZE = 50; // eSign offset is 50
    return this.queryESignAllAgreementsListFoldersByIndex(access_token, 0).then( (res = {}) => {
      let { ret, message, data: { forwardResult = {}} = {}} = res;
      if (ret ===  0 && message.toLowerCase() ==='success') {
        let { folders_count } = forwardResult;
        let promises = [];
        promises.push(Promise.resolve(res));
        if (folders_count > PAGE_SIZE) {
          let pageSize = Math.ceil(folders_count/PAGE_SIZE);
          for (let index = 1; index < pageSize; index++) {
            promises.push(this.queryESignAllAgreementsListFoldersByIndex(access_token, index));
          }
        }
        return Promise.all(promises)
      } else {
        return Promise.reject('QueryESignAgreementsList error! ')
      }
    }, () => {
      return Promise.reject('QueryESignAgreementsList error! ')
    }).then( allFolderList => {
      let allFolderIds = [];
      for (let index = 0; index < allFolderList.length; index++) {
        let { ret, message, data: { forwardResult = {}} = {}} = allFolderList[index];
        if (ret ===  0 && message.toLowerCase() ==='success' && forwardResult) {
          allFolderIds.push(...forwardResult.allFolders);
        }
      }
      return this.queryESignAllAgreementsListByFolderIds(access_token, allFolderIds)
    }, err => {
      return Promise.reject(err)
    })
  }

  queryESignAgreementsListByStatus(access_token, status)  {
    return this.get({
      url: this.FORWARDAPI,
      config: {
        params: {
          access_token,
          apiKey: `api/folders/list/${status}`
        },
      },
    })
  }

  queryESignAgreementsList(status, isAll = false) {
    return this.createESignAccessToken().then( access_token => {
      return isAll ? this.queryESignAllAgreementsList(access_token) : this.queryESignAgreementsListByStatus(access_token, status)
    }, err => {
      return Promise.reject(err);
    }).then( res => {
      let { ret, message, data: { forwardResult = {}} = {}} = res;
      if (ret ===  0 && message.toLowerCase() ==='success') {
        return forwardResult;
      } else {
        return Promise.reject('QueryESignAgreementsList error! ')
      }
    }, err => {
      return Promise.reject(err);
    })
  }
  getFillSignSignature() {
    /**
     * 通过getFoxitSign参数来控制显示什么签名：
     * getFoxitSign 参数，0：获取个人签名，1：获取个人签名+esign，2：获取esign，默认为0
     * 下载可使用返回的imgUrl字段
     * 区分个人签名和esign，个人签名有"_id"字段，esign有"fieldType"字段
     */
    return store.userStore.getToken().then( token => {
      return new Promise((resolve, reject) => {
        let url = '/fill-sign/list';
        this.get({
          url,
          config: {
            params: {
              'access-token': token,
              getFoxitSign: 0
            }
          }
        }).then( async (res = {}) => {
          let { ret,  data: { signList = []} = {}} = res;
          let list = [];
          if (ret === 0) {
            list = signList.map(item => {
              return{
                ...item,
                id: item._id.$oid,
              }
            })
          }
          resolve(list);
        }, err => {
          reject(err)
        })
      });
    }, (err) => {

      return Promise.reject(err);
    })
  }
  uploadFillSignSignature({imageType= 'image/png', content = ''}) {
    return store.userStore.getToken().then( token => {
      return new Promise((resolve, reject) => {
        let url = '/server/upload-image';
        this.post({
          url,
          config: {
            params: {
              'access-token': token,
            },
          },
          data: qs.stringify({
            imageType,
            content
          })
        }).then( (res = {}) => {
          let { data} = res;
          resolve(data);
        }, err => {
          reject(err)
        })
      });
    }, (err) => {
      return Promise.reject(err);
    })
  }
  deleteFillSignSignature(signId = '') {
    return store.userStore.getToken().then( token => {
      return new Promise((resolve, reject) => {
        let url = '/fill-sign/delete-sign';
        this.post({
          url,
          config: {
            params: {
              'access-token': token,
            }
          },
          data: qs.stringify({
            signId
          })
        }).then( (res = {}) => {
          resolve(res);
        }, err => {
          reject(err)
        })
      });
    }, (err) => {
      return Promise.reject(err);
    })
  }
  getFillSignSignatureBase64(url = '') {
    return new Promise((resolve, reject) => {
      this.get({
        url,
        config: {
          responseType: 'blob'
        }
      }).then(blobToBase64).then(result => {
        if (result && result.ret === 0) {
          resolve(result.data);
        } else {
          reject('Get SignSignatureBase64 Error')
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  // 创建信封
  createEnvelope(isUseCacheESignToken = true) {
    let { eSign_token }  = store.userStore;
    return (isUseCacheESignToken && eSign_token ? Promise.resolve(eSign_token) : this.createESignAccessToken()).then( access_token => {
      return new Promise((resolve, reject) => {
        const docName = store.docStore.docInfo.fileName;
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token
            },
          },
          data: {
            apiKey: 'api/folders/createEnvelope',
            'contentType': 'application/json',
            fileNames: [docName],
            envelopeName: docName,
            envelopeTransactionSource: "foxitEditor"
          }
        }).then(res => {
          let { ret, data: { forwardResult: { result, documentIds, envelopeId, saveDocumentOnline } = {} } = {} } = res;
          if (ret === 0 && result === 'success' && documentIds) {
            resolve({ documentIds, envelopeId, saveDocumentOnline });
          } else {
            reject('createEnvelope error! ')
          }
        }, () => {
          reject('createEnvelope error! ')
        });
      });
    }, err => {
      Promise.reject(err);
    })
  }
  // 获取本机物理地址
  getClientInfo() {
    // Get client IP and location
    const { userIp, userCountry } = store.appStore.phantomOnlineGlobalConfig;
    return { userIp, userCountry };
  }
  // 更新信封记录
  updateEnvelopeHistory(envelopeId, changeType = 'EnvelopeSigned', isUseCacheESignToken = true) {
    let { eSign_token }  = store.userStore;
    return (isUseCacheESignToken && eSign_token ? Promise.resolve(eSign_token) : this.createESignAccessToken()).then( access_token => {
      return new Promise((resolve, reject) => {
        const { userIp, userCountry } = this.getClientInfo();
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token
            },
          },
          data: {
            apiKey: 'api/folders/updateEnvelopeHistory',
            'contentType': 'application/json',
            "envelopeId": envelopeId,
            // "change_date": "2021-04-23 18:25:43",     //Please pass the date/time values in PST timezone only.
            "change_type": changeType,
            // "EnvelopeSigned",
            "source": "foxitEditor",
            "location": userCountry,
            "ipAddress": userIp
          }
        }).then((res = {}) => {
          let { ret, data: { forwardResult: { result } = {} } = {} } = res;
          if (ret === 0 && result === 'success') {
            resolve();
          } else {
            reject('updateEnvelopeHistory error! ')
          }
        }, () => {
          reject('updateEnvelopeHistory error! ')
        });
      });
    }, err => {
      Promise.reject(err);
    })
  }
  // 获取签名图片
  getPartySignImage(base64ImageSource, fieldType, isUseCacheESignToken = true) {
    let { eSign_token }  = store.userStore;
    return (isUseCacheESignToken && eSign_token ? Promise.resolve(eSign_token) : this.createESignAccessToken()).then( access_token => {
      return new Promise((resolve, reject) => {
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token
            },
          },
          data: {
            apiKey: 'api/parties/getPartySignImage',
            'contentType': 'application/json',
            "fieldType": fieldType,
            "imageSource": base64ImageSource
          }
        }).then((res = {}) => {
          let { ret, data: { forwardResult: { imageSourceWithDetails /*, imageSource, signerId */ } = {} } = {} } = res;
          if (ret === 0 && imageSourceWithDetails) {
            resolve(imageSourceWithDetails);
          } else {
            reject('getPartySignImage error! ')
          }
        }, () => {
          reject('getPartySignImage error! ')
        });
      });
    } , err => {
      Promise.reject(err);
    })
  }
  // 转换文档签名摘要
  getPKCS7(docHash, isUseCacheESignToken = true) {
    let { eSign_token }  = store.userStore;
    return (isUseCacheESignToken && eSign_token ? Promise.resolve(eSign_token) : this.createESignAccessToken()).then( access_token => {
      return new Promise((resolve, reject) => {
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token
            },
          },
          data: {
            apiKey: 'api/folders/getPKCS7',
            'contentType': 'application/json',
            digestBASE64: docHash
          }
        }).then((res = {}) => {
          let { ret, data: { forwardResult: { pkcs7Data } = {} } = {} } = res;
          if (ret === 0 && pkcs7Data) {
            resolve(pkcs7Data);
          } else {
            reject('getPKCS7 error! ')
          }
        }, () => {
          reject('getPKCS7 error! ')
        });
      });
    } , err => {
      Promise.reject(err);
    })
  }
  // 上传签名文档
  uploadExecutedDocument(envelopeId, documentIds, docHash, signatureSource, isUseCacheESignToken = true) {
    let { eSign_token }  = store.userStore;
    return (isUseCacheESignToken && eSign_token ? Promise.resolve(eSign_token) : this.createESignAccessToken()).then( access_token => {
      return new Promise((resolve, reject) => {
        const { userIp, userCountry } = this.getClientInfo();
        let params = {
          "envelopeId": envelopeId,
          "documentIds": documentIds,
          "base64FileString": [docHash],
          "ipAddress": userIp,
          "location": userCountry
        };
        if (signatureSource) {
          params.signatureSource = signatureSource;
        }
        this.post({
          url: this.FORWARDAPI,
          config: {
            params: {
              access_token
            },
          },
          data: {
            apiKey: 'api/folders/uploadExecutedDocument',
            'contentType': 'application/json',
            ...params
          }
        }).then((res = {}) => {
          let { ret, data: { forwardResult: { result = '', message } = {} } = {} } = res;
          if (ret === 0 && result === 'success') {
            resolve();
          } else {
            reject(message || 'Get token error! ')
          }
        }, () => {
          reject('Get token error! ')
        });
      });
    } , err => {
      Promise.reject(err);
    })
  }
  // 一个online 账户 可能有多个 esign 账户
  getUserCompanyDetail(email) {
    const { token } = store.userStore;

    return this.get({
      url: this.FORWARDAPI,
      config: {
        params: {
          access_token: token,
          apiKey: 'api/v1/accounts/usercompanydetail',
          email
        },
      },
    }).then( res => {
      let { ret, message, data: { forwardResult } = {}} = res;
      if (ret ===  0 && message.toLowerCase() ==='success') {
        return forwardResult;
      } else {
        return Promise.reject('Query eSign Multiple account error! ')
      }
    }, err => {
      return Promise.reject(err);
    })
  }
  // 一个online 企业账户 可能有多个 esign 账户
  getEsignEnterpriseUserCompanyDetail = async (isNeedFilter = true) => {
    try {
      const currentEnterpriseId = _get(store.userStore, 'roleInfo.enterpriseId')
      const result = await baseUrlApis.getUserInfoByToken(store.userStore.token);
      if (result) {
        let { ret, data } = result;
        if (ret == 0 && data) {
          let enterpriseCompanyIds = _get(data, 'enterpriseList.enterprise.companyId');
          let enterpriseId = _get(data, 'enterpriseList.enterprise.id');
          let invitedCompany = _get(data, 'enterpriseList.invitedByEnts');
          let companies = [];
          if (enterpriseCompanyIds && Array.isArray(enterpriseCompanyIds)) {
            enterpriseCompanyIds = enterpriseCompanyIds.map(item => (item + ''))
            if (!isNeedFilter || enterpriseId && enterpriseId === currentEnterpriseId) {
              companies = [...enterpriseCompanyIds];
            }
          }
          if (invitedCompany && Array.isArray(invitedCompany)) {
            let currentInvitedEsignAccounts = [...invitedCompany];
            if (isNeedFilter) {
              currentInvitedEsignAccounts = invitedCompany.filter(item => item.id === currentEnterpriseId);
            }
            if (currentInvitedEsignAccounts.length) {
              let _companies = currentInvitedEsignAccounts.reduce( (prev, cur) => {
                if (Array.isArray(cur.companyId)) {
                  prev.push(...cur.companyId.map( item => (item + '')));
                }
                return prev;
              }, [])
              companies.push(..._companies);
            }
          }
          companies = [...new Set(companies)];
          let _companiesObj = companies.map( item => ({companyId: item}));
          return Promise.resolve({
            enterpriseCompanyIds,
            enterpriseId,
            invitedCompany,
            companies,
            companiesObj: _companiesObj
          });
        }
      }
      return Promise.reject('GetUserInfoByToken error')
    } catch (err) {
      return Promise.reject(err);
    }
  }
  getUserCompanySubscriptionDetails(companyId) {
    const { token } = store.userStore;

    return this.get({
      url: this.FORWARDAPI,
      config: {
        params: {
          access_token: token,
          apiKey: 'api/v1/accounts/subscriptiondetails',
          companyId
        },
      },
    }).then( res => {
      let { ret, message, data: { forwardResult } = {}} = res;
      if (ret ===  0 && message.toLowerCase() ==='success' && forwardResult) {
        return forwardResult.plan;
      } else {
        return Promise.reject('Query eSign account SubscriptionDetails error! ')
      }
    }, err => {
      return Promise.reject(err);
    })
  }
}
